import './App.css'
import {EulaPopup} from "./eula/EulaPopup.tsx";
import {AppSwitcher} from "./AppSwitcher.tsx";
import {AppHeader} from "./components/AppHeader.tsx";

function App() {
  return (
    <>
        <EulaPopup />
        <AppHeader />
        <div className="AppContent">
            <AppSwitcher />
        </div>
    </>
  )
}

export default App
